import { QueryKey, useQueryClient } from 'react-query';

export function useInvalidateQueries() {
    const query = useQueryClient();

    const invalidate = async (...queryNames: QueryKey[]) => {
        const keySet = new Set();
        return Promise.all(
            queryNames
                ?.concat(['gradebookData', 'gradebookStudents'])
                .filter((key) => {
                    if (keySet.has(key)) {
                        return false;
                    }
                    keySet.add(key);
                    return true;
                })
                .map((queryName) => {
                    const qKey = typeof queryName === 'string' ? [queryName] : queryName;

                    return query.invalidateQueries(qKey);
                }),
        );
    };

    return invalidate;
}
